module.exports = __webpack_public_path__ + "src/assets/games/11/62.jpg";